import { APIS } from "../../../_config";
import { CallApi } from "../callApi";

export interface ExternalInputFormData {
  file?: File;
  unique_key?: string;
  page?: number;
  per_page?: number;
  [key: string]: any; // Allow any additional parameters
}

export function useExternalInputApi(){

    const uploadFile = async (data: ExternalInputFormData): Promise<any> => {
        // Extract data properties
        const { file, unique_key, ...params } = data;
        
        // Build the URL with query params
        let url = APIS.WINE_ADDITION.EXTERNAL_INPUT.UPLOAD_FILE;
        
        // Prepare query parameters
        const queryParams = { ...params };
        
        // Add unique_key to query params if present
        if (unique_key) {
            queryParams.unique_key = unique_key;
        }
        
        // Add query parameters to URL
        if (Object.keys(queryParams).length > 0) {
            const queryString = Object.entries(queryParams)
                .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
                .join('&');
            url = `${url}?${queryString}`;
        }
        
        // If we have a file, create FormData and send it
        if (file) {
            const formData = new FormData();
            formData.append("file", file);
            const response = await CallApi.POST(url, formData, true);   
            return response;
        } else {
            // Otherwise just send a request with the query parameters (using empty object as body)
            const response = await CallApi.POST(url, {}, true);
            return response;
        }
    };

    const checkMatch = async (params: any = {}): Promise<any> => {
        return CallApi.GET(APIS.WINE_ADDITION.EXTERNAL_INPUT.CHECK_MATCH,{...params}, true);
    };

    const undoMatch = async (params: any = {}): Promise<any> => {
        return CallApi.PUT(APIS.WINE_ADDITION.EXTERNAL_INPUT.UNDO_MATCH, {...params}, true);
    };

    const acceptMatch = async (params: any = {}): Promise<any> => {
        return CallApi.PUT(APIS.WINE_ADDITION.EXTERNAL_INPUT.ACCEPT_MATCH, {...params}, true);
    };

    return {
        uploadFile,
        checkMatch,
        undoMatch,
        acceptMatch
    };
}